import { NextPage } from 'next';
import ListCheckBox from '../ListCheckBox';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

interface Props {
  options: any[];
  value: string;
  selectedItem: any;
  selectedValue: any;
  setSelectedItem: Dispatch<SetStateAction<any>>;
}

const SelectionCheckBox: NextPage<Props> = ({
  options,
  value,
  selectedItem,
  setSelectedItem,
  selectedValue,
}) => {
  const [section, setSection] = useState(null);

  const listSection = [
    {
      key: 'A/T',
      label: 'OTOMATIS',
    },
    {
      key: 'M/T',
      label: 'MANUAL',
    },
  ].filter((item) => {
    return options.some((opt) => opt.transmission === item.key);
  });

  useEffect(() => {
    const hasAT = options.some((opt) => opt.transmission === 'A/T');
    const hasMT = options.some((opt) => opt.transmission === 'M/T');
    const optionValue = options.find((item) => item.id === value);
    if (optionValue) {
      setSection(optionValue.transmission);
    } else {
      if (hasAT) {
        setSection('A/T');
      } else if (!hasMT) {
        setSection('M/T');
      }
    }
  }, [options, value]);

  const filteredOptions = options.filter((item) => {
    return item.transmission === section;
  });

  return (
    <>
      <div className="flex w-full h-full flex-col">
        <div className="flex w-full h-[62px] px-4 py-2">
          <div className="w-full h-full flex p-1">
            {listSection?.flatMap(
              (
                res: {
                  key: string;
                  label: string;
                },
                idx: number
              ) => {
                return (
                  <div
                    key={idx}
                    onClick={() => setSection(res.key)}
                    className={`flex ${listSection.length === 2 ? 'w-1/2' : 'w-full'} cursor-pointer font-semibold text-xs text-[background: #FFFEFE] text-center justify-center items-center rounded ${res.key === section ? 'text-white bg-[#231F20]' : 'text-[231F20] bg-[#F4F4F4]'}`}
                  >
                    {res.label}
                  </div>
                );
              }
            )}
          </div>
        </div>

        <ListCheckBox
          items={filteredOptions}
          selectedItem={selectedItem}
          selectedValue={selectedValue}
          setSelectedItem={setSelectedItem}
        />
      </div>
    </>
  );
};

export default SelectionCheckBox;
